var render = function render(){var _vm=this,_c=_vm._self._c;return _c('order-base',{attrs:{"order":_vm.order},scopedSlots:_vm._u([{key:"positions",fn:function(){return [_c('order-positions-list',{attrs:{"declined":_vm.order.declinedPositions,"currency":_vm.order.currency,"show-declined":true}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }